import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Row, Col, Container, Button, Input, Label, Form } from 'reactstrap';

import Page from '../../components/Layout/Page/Page';
import RoundedButton from '../../components/Buttons/RoundedButton/RoundedButton';
import TrackWave from '../../components/Tracks/TrackWave/TrackWave';
import PlaylistRow from '../../components/Playlists/PlaylistRow/PlaylistRow';
import PlaylistTrackRow from '../../components/Playlists/PlaylistTrackRow/PlaylistTrackRow';
import Loader from '../../components/Common/Loader';
import PlayButton from '../../components/Buttons/PlayButton/PlayButton';

import { ReactComponent as TrashIcon } from '../../assets/images/trash.svg';

import { loadUserPlaylists, createPlaylist } from '../../helpers/api/playlists.api';

import './Playlists.scss';

const Playlists = props => {
    const [loading, setLoading] = useState(true);

    const [creating, setCreating] = useState(false);
    const [creatingLoading, setCreatingLoading] = useState(false);
    const [creatingError, setCreatingError] = useState(null);

    const [playlists, setPlaylists] = useState([]);
    const [selectedPlaylist, setSelectedPlaylist] = useState(null);
    const [track, setTrack] = useState(null);

    const [playing, setPlaying] = useState(false);

    useEffect(() => {
        load();
    }, []);

    useEffect(() => {
        if (playlists && playlists.length > 0)
            setSelectedPlaylist(playlists[0])
    }, [playlists]);

    useEffect(() => {
        if (selectedPlaylist && selectedPlaylist.tracks)
            setTrack(selectedPlaylist.tracks[0]);
    }, [selectedPlaylist]);

    function load() {
        setLoading(true);
        loadUserPlaylists()
            .then((result) => {
                if (result.success) {
                    setPlaylists(result.playlists);
                } else {
                    console.log(result.message);
                    setPlaylists([]);
                }
                setLoading(false);
            })
            .catch((error) => {
                setPlaylists([]);
                setLoading(false);
                console.log(error);
            });
    }

    function handleOnCreatePlaylist(event) {
        event.preventDefault();
        setCreatingError(null);
        setCreatingLoading(true);
        createPlaylist(event.target['title'].value)
            .then(result => {
                if (result.success) {
                    setCreating(false);
                    setCreatingError(null);
                    load();
                } else
                    setCreatingError(result.message);
                setCreatingLoading(false);
            })
            .catch((error) => {
                setCreatingError(error);
                setCreatingLoading(false);
            });
    }

    const tracks = selectedPlaylist ? selectedPlaylist.tracks : [];

    return <Page className="playlists">
        <Container fluid className="h-100 d-flex flex-column">
            <Row className="h-100">
                <Col lg="9">
                    <Row>
                        <Col style={{borderRight: '1px solid white'}}>
                            <h4>Playlist</h4>
                            {selectedPlaylist && <h5 className="playlist-title">{selectedPlaylist.title}</h5>}
                            {loading ?
                                <Loader className="mt-5" />
                                : <div className="playlist-content">
                                    <Row className="pb-lg-3">
                                        <Col className="d-flex flex-column justify-content-between">
                                            {track ?
                                                <>
                                                    <Row>
                                                        <Col xs="12" lg="8" className="d-flex align-items-center justify-content-between">
                                                            <div className="d-flex flex-column mr-5">
                                                                <h4>{track.title}</h4>
                                                            </div>
                                                            <PlayButton playing={playing} onClick={() => setPlaying(!playing)} />
                                                        </Col>
                                                        <Col lg="4" className="d-none d-lg-flex align-items-center justify-content-end">
                                                            <RoundedButton color="primary" className="px-3" onClick={() => props.history.push('/users/' + track.author._id)}>VISUALIZZA Profilo</RoundedButton>
                                                        </Col>
                                                    </Row>
                                                    <div className="wave-wrapper mt-5 pb-0">
                                                        <TrackWave audioFile={track.file.url} playing={playing} />
                                                    </div>
                                                </> : null}
                                        </Col>
                                    </Row>

                                    <Row className="pt-lg-3">
                                        <Col className="">
                                            <ul className="tracks-list mb-5 mb-lg-0">
                                                {tracks.map(t => <PlaylistTrackRow key={t.id} playlistId={selectedPlaylist._id} track={t} onPlayClick={() => setTrack(t)} onRemoveComplete={load} />)}
                                            </ul>
                                        </Col>
                                    </Row>
                                </div>}
                        </Col>
                    </Row>

                </Col>
                <Col lg="3">
                    <h5>Elenco Playlist</h5>
                    <ul className="playlists-list">
                        {playlists.map((pl, i) => {
                            return <PlaylistRow key={pl._id} id={pl._id} onClick={() => setSelectedPlaylist(pl)} 
                            title={pl.title} onDeleteComplete={load} />
                        })}
                    </ul>
                    {!creating ? <RoundedButton className="mb-5" color="primary" onClick={() => {
                        setCreatingError(null); setCreating(true);
                    }}>
                        Crea Nuova
                    </RoundedButton>
                        : creatingLoading ?
                            <Loader />
                            : <Form className="mb-5" onSubmit={handleOnCreatePlaylist}>
                                <Label htmlFor="title">Titolo nuova playlist</Label>
                                <Input type="text" id="title" name="title" />
                                <RoundedButton color="primary" type="submit">
                                    Crea
                                </RoundedButton>
                                <p>{creatingError}</p>
                            </Form>}
                </Col>
            </Row>
        </Container>
    </Page>;
}

const mapStatetoProps = (state) => {
    return { user: state.Auth.user };
};

export default connect(mapStatetoProps, {})(Playlists);